import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** 与 `entrypoints/application.css` 中 `.font-numeric` 配套，用于等宽、易读数字 */
export const fontNumeric = "font-numeric" as const
export const fontNumericStrong = "font-numeric-strong" as const

/** 侧栏等单行摘要：弱化 Markdown 标记，减少 `**`、`` ` `` 等噪音 */
export function plainTextFromMarkdownLoose(s: string): string {
  return s
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) =>
      line
        .replace(/^#{1,6}\s+/, "")
        .replace(/^\s*[-*+]\s+/, "")
        .replace(/^\s*\d+\.\s+/, ""),
    )
    .join(" ")
    .replace(/[*_`]+/g, "")
    .replace(/\[([^\]]*)]\([^)]*\)/g, "$1")
    .replace(/\s+/g, " ")
    .trim()
}
